import http from '../utils/http'

export default {
    getTournamentAdminCalls (tournamentId) {
        return http.get(`/chats/${tournamentId}/admin-calls`);
    }
}
